import { render, staticRenderFns } from "./StatPanel.vue?vue&type=template&id=9ce48476&scoped=true"
import script from "./StatPanel.vue?vue&type=script&lang=js"
export * from "./StatPanel.vue?vue&type=script&lang=js"
import style0 from "./StatPanel.vue?vue&type=style&index=0&id=9ce48476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce48476",
  null
  
)

export default component.exports